<script>
import ElAvatar from 'element-ui/packages/avatar/src/main'

export default {
  name: 'ElAvatar',
  extends: ElAvatar,
  watch: {
    src () {
      this.isImageExist = true
    },
    srcSet () {
      this.isImageExist = true
    }
  },
  render (h) {
    const vnode = ElAvatar.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-avatar']
    return vnode
  }
}
</script>
